/**
 * Utility helpers to filter out inactive / not-in-use master records
 * from dropdowns, selects, and references across the application.
 */

export const isNotInUse = (item) => {
  if (!item) return false;
  if (item.IsNotInUse === true || item.IsNotInUse === 1 || item.IsNotInUse === "1" || String(item.IsNotInUse).toLowerCase() === "true") {
    return true;
  }
  if (item.isNotInUse === true || item.isNotInUse === 1 || item.isNotInUse === "1" || String(item.isNotInUse).toLowerCase() === "true") {
    return true;
  }
  if (item.NotInUse === true || item.NotInUse === 1 || item.NotInUse === "1" || String(item.NotInUse).toLowerCase() === "true") {
    return true;
  }
  if (item.notInUse === true || item.notInUse === 1 || item.notInUse === "1" || String(item.notInUse).toLowerCase() === "true") {
    return true;
  }
  if (item.IsActive === false || item.IsActive === 0 || item.IsActive === "0" || String(item.IsActive).toLowerCase() === "false") {
    return true;
  }
  if (item.isActive === false || item.isActive === 0 || item.isActive === "0" || String(item.isActive).toLowerCase() === "false") {
    return true;
  }
  return false;
};

/**
 * Filters a list of master records to only active ones.
 * Optionally keeps a currently selected ID so historical/existing form records don't break.
 */
export const filterActiveMasters = (list, selectedId) => {
  if (!Array.isArray(list)) return [];
  return list.filter((item) => {
    if (!isNotInUse(item)) return true;
    if (selectedId !== undefined && selectedId !== null && selectedId !== "" && String(item.Id) === String(selectedId)) {
      return true;
    }
    return false;
  });
};

export default filterActiveMasters;
